import fetch from 'cross-fetch'

import { API_ADDR } from '../config/config'
export const ADDRESS_TRANSFER_INIT = 'ADDRESSES_TRANSFER_INIT'
export const ADDRESS_TRANSFER_UPDATE = 'ADDRESS_TRANSFER_UPDATE'

export function initAddressTransfer() {
  return {
    type: ADDRESS_TRANSFER_INIT,
  }
}
export function updateAddressTransfer(addressTransfer, total, status) {
  return {
    type: ADDRESS_TRANSFER_UPDATE,
    payload: {
      result: addressTransfer,
      total: total,
      status: status,
    },
  }
}

export function loadAddressTransfer(type, address, offset, limit, date) {
  var start = 0
  var end = 0
  if (date != null) {
    if (date.length == 2) {
      start = date[0].valueOf()
      end = date[1].valueOf()
    }
  }

  return (dispatch) => {
    dispatch(initAddressTransfer())
    fetch(
      `${API_ADDR}/address/transfer/${type}/${address}?start=${start}&end=${end}&num=${offset}&limit=${limit}&sort=desc`,
      {
        method: 'GET',
        mode: 'cors',
      }
    )
      .then((res) => res.json())
      .then(async (res) => {
        dispatch(updatePageAddressTransferTotal(res.data.total + 1))
        dispatch(updatePageAddressTransferStart(res.data.total))
        dispatch(updateAddressTransfer(res.data.result, res.data.total, res.status))
      })
      .catch((err) => {})
  }
}

export const PAGE_ADDRESS_TRANSFER_INIT = 'PAGE_ADDRESS_TRANSFER_INIT'
export const PAGE_ADDRESS_TRANSFER_UPDATE = 'PAGE_ADDRESS_TRANSFER_UPDATE'
export const PAGE_ADDRESS_TRANSFER_TOTAL_UPDATE = 'PAGE_ADDRESS_TRANSFER_TOTAL_UPDATE'
export const PAGE_ADDRESS_TRANSFER_LIMIT_UPDATE = 'PAGE_ADDRESS_TRANSFER_LIMIT_UPDATE'
export const PAGE_ADDRESS_TRANSFER_START_UPDATE = 'PAGE_ADDRESS_TRANSFER_START_UPDATE'

export function initPageAddressTransfer() {
  return {
    type: PAGE_ADDRESS_TRANSFER_INIT,
  }
}
export function updatePageAddressTransfer(page) {
  return {
    type: PAGE_ADDRESS_TRANSFER_UPDATE,
    payload: page,
  }
}

export function updatePageAddressTransferTotal(total) {
  return {
    type: PAGE_ADDRESS_TRANSFER_TOTAL_UPDATE,
    payload: total,
  }
}

export function updatePageAddressTransferLimit(limit) {
  return {
    type: PAGE_ADDRESS_TRANSFER_LIMIT_UPDATE,
    payload: limit,
  }
}

export function updatePageAddressTransferStart(start_page) {
  return {
    type: PAGE_ADDRESS_TRANSFER_START_UPDATE,
    payload: start_page,
  }
}
